// extracted by mini-css-extract-plugin
export default {"chatBox":"chat_chatBox__oUJUn","desBox":"chat_desBox__PNO6P"};